// extracted by mini-css-extract-plugin
export default {"mappingForm":"mappingForm---nV3Ei","colWithTable":"colWithTable---h_l9Q","addFieldButton":"addFieldButton---SxIaT"};